import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("新しいお知らせを作成")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" お知らせを登録 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_link_list = _resolveComponent("m-link-list")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_base_modal = _resolveComponent("m-base-modal")

  return (_openBlock(), _createBlock(_component_m_base_modal, { onClose: _ctx.close }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_m_text_field, {
          label: "日付",
          name: "date",
          type: "date",
          placeholder: "日付を入力",
          value: _ctx.date,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.date = $event))
        }, null, 8, ["value"])
      ]),
      _createVNode(_component_m_link_list, {
        class: "w-3/4 mx-auto mb-6",
        links: _ctx.editingLinks,
        term: "リンク",
        "is-direct-url-editor-only": true,
        limit: 1,
        onUpdate: _ctx.onUpdateLinks
      }, null, 8, ["links", "onUpdate"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.validData,
        onClick: _ctx.createServiceTopic
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
}